exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".type-cell[data-v-4d977d50]{min-height:45px}", ""]);

// exports
